import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { complexityid, libTypeIds, RESULT_STATUS } from "../../../constants";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useAuth from "../../../Hooks/useAuth";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import Table from "../../CommonComponents/Table";
import { LibraryContext } from "../../../context/LibraryContext";
import { useDebouncedValue } from "../../../Hooks/useDebounceValue";
import { DropdownMenu } from "../../CommonComponents/InputDropdown";
import Modal from "../../CommonComponents/Modal";
import { AddTopic } from "./LibraryUtils";
import ModalBody from "../../CommonComponents/ModalBody";
import Button from "../../Button";
import QuestionList from "./QuestionList";
import SharedTopics from "./SharedTopics";
import NoSubjects from "./NoSubjects";
import Loading from "../../Notification-Loading/Loading/Loading";
import Tooltip from "../../CommonComponents/Tooltip";
import ReusableBreadcrumbs from "../../CommonComponents/ReusableBreadCrumbs";

const complexityIcon = {
  1: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8333 6.55715V7.17048C13.8325 8.6081 13.367 10.0069 12.5062 11.1584C11.6454 12.3098 10.4355 13.1521 9.0569 13.5597C7.67829 13.9674 6.20484 13.9184 4.85631 13.4202C3.50779 12.922 2.35644 12.0012 1.57397 10.7952C0.791511 9.58917 0.419861 8.16253 0.514451 6.72803C0.609042 5.29353 1.1648 3.92803 2.09885 2.8352C3.0329 1.74236 4.29519 0.980737 5.69746 0.663913C7.09973 0.347089 8.56685 0.49204 9.88 1.07715M13.8333 1.83333L7.16667 8.50667L5.16667 6.50667"
        stroke="#12B76A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  2: (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.73341 12.0807L5.12304 12.957C5.23887 13.2179 5.4279 13.4395 5.66719 13.5951C5.90649 13.7506 6.18578 13.8334 6.47119 13.8333C6.7566 13.8334 7.03589 13.7506 7.27519 13.5951C7.51449 13.4395 7.70351 13.2179 7.81934 12.957L8.20897 12.0807C8.34767 11.7698 8.58097 11.5106 8.87564 11.34C9.17216 11.169 9.51519 11.0961 9.85564 11.1319L10.809 11.2333C11.0927 11.2633 11.3791 11.2104 11.6334 11.0809C11.8877 10.9514 12.099 10.7509 12.2416 10.5037C12.3843 10.2567 12.4524 9.97352 12.4374 9.68859C12.4224 9.40366 12.325 9.1292 12.1571 8.89852L11.5927 8.12296C11.3917 7.84475 11.2843 7.50988 11.286 7.16667C11.2859 6.82439 11.3943 6.4909 11.5956 6.21407L12.1601 5.43852C12.328 5.20784 12.4254 4.93338 12.4403 4.64845C12.4553 4.36352 12.3873 4.08036 12.2445 3.83333C12.1019 3.58616 11.8907 3.38566 11.6364 3.25615C11.3821 3.12664 11.0957 3.07369 10.8119 3.1037L9.8586 3.20519C9.51815 3.24094 9.17512 3.16808 8.8786 2.99704C8.58335 2.8255 8.34998 2.56491 8.21193 2.25259L7.81934 1.3763C7.70351 1.11545 7.51449 0.89381 7.27519 0.738266C7.03589 0.582722 6.7566 0.499953 6.47119 0.5C6.18578 0.499953 5.90649 0.582722 5.66719 0.738266C5.4279 0.89381 5.23887 1.11545 5.12304 1.3763L4.73341 2.25259C4.59537 2.56491 4.362 2.8255 4.06675 2.99704C3.77022 3.16808 3.42719 3.24094 3.08675 3.20519L2.13045 3.1037C1.84667 3.07369 1.56028 3.12664 1.30599 3.25615C1.05171 3.38566 0.840461 3.58616 0.697858 3.83333C0.555072 4.08036 0.487047 4.36352 0.502036 4.64845C0.517025 4.93338 0.614385 5.20784 0.782302 5.43852L1.34675 6.21407C1.54804 6.4909 1.65644 6.82439 1.65638 7.16667C1.65644 7.50894 1.54804 7.84243 1.34675 8.11926L0.782302 8.89481C0.614385 9.1255 0.517025 9.39995 0.502036 9.68488C0.487047 9.96982 0.555072 10.253 0.697858 10.5C0.840602 10.747 1.05188 10.9474 1.30612 11.0769C1.56037 11.2064 1.84669 11.2595 2.13045 11.2296L3.08378 11.1281C3.42423 11.0924 3.76726 11.1653 4.06378 11.3363C4.36014 11.5073 4.59459 11.768 4.73341 12.0807Z"
        stroke="#FDB022"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.47 9.16667C7.57457 9.16667 8.47 8.27124 8.47 7.16667C8.47 6.0621 7.57457 5.16667 6.47 5.16667C5.36543 5.16667 4.47 6.0621 4.47 7.16667C4.47 8.27124 5.36543 9.16667 6.47 9.16667Z"
        stroke="#FDB022"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  3: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.8333 4.5V2.5L11.8333 0.5L12.5 1.83333L13.8333 2.5L11.8333 4.5H9.8333ZM9.8333 4.5L7.16665 7.16663M13.8333 7.16667C13.8333 10.8486 10.8486 13.8333 7.16667 13.8333C3.48477 13.8333 0.5 10.8486 0.5 7.16667C0.5 3.48477 3.48477 0.5 7.16667 0.5M10.5 7.16667C10.5 9.00762 9.00762 10.5 7.16667 10.5C5.32572 10.5 3.83333 9.00762 3.83333 7.16667C3.83333 5.32572 5.32572 3.83333 7.16667 3.83333"
        stroke="#F04438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

const RowActionMenu = ({ row, openMenuId, onToggle, onAction }) => {
  const anchorRef = useRef(null);
  const dropdownId = `topic-row-menu-${row.tid}`;
  const isOpen = openMenuId === row.tid;

  return (
    <div className="subject-table-total_count-column" ref={anchorRef}>
      <span>{row.total_count}</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={(e) => {
          e.stopPropagation();
          onToggle(isOpen ? null : row.tid);
        }}
      >
        <path
          d="M10.0013 10.8333C10.4615 10.8333 10.8346 10.4602 10.8346 9.99992C10.8346 9.53968 10.4615 9.16659 10.0013 9.16659C9.54106 9.16659 9.16797 9.53968 9.16797 9.99992C9.16797 10.4602 9.54106 10.8333 10.0013 10.8333Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0013 4.99992C10.4615 4.99992 10.8346 4.62682 10.8346 4.16659C10.8346 3.70635 10.4615 3.33325 10.0013 3.33325C9.54106 3.33325 9.16797 3.70635 9.16797 4.16659C9.16797 4.62682 9.54106 4.99992 10.0013 4.99992Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0013 16.6666C10.4615 16.6666 10.8346 16.2935 10.8346 15.8333C10.8346 15.373 10.4615 14.9999 10.0013 14.9999C9.54106 14.9999 9.16797 15.373 9.16797 15.8333C9.16797 16.2935 9.54106 16.6666 10.0013 16.6666Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {isOpen && (
        <DropdownMenu
          anchorRef={anchorRef}
          options={[
            { label: "Edit", value: "edit" },
            { label: "Delete", value: "delete" },
          ]}
          onSelectOption={(val) => {
            onAction(val, row);
          }}
          value={null}
          dropdownId={dropdownId}
          open={isOpen}
          onClose={() => onToggle(null)}
        />
      )}
    </div>
  );
};

const Subjects = memo(function Subjects({ isShared = false }) {
  const axios = useAxiosPrivate();
  const { setShowNotify } = useAuth();
  const {
    searchText,
    setSearchText,
    subjects,
    setSubjects,
    topics,
    setTopics,
    selectedSubject,
    setSelectedSubject
  } = useContext(LibraryContext);
  const { type } = useParams();
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const subId = searchParams.get("subId");
  const topId = searchParams.get("topId");
  const isSharedPage = pathname.includes("/shared");
  const isMcq = +type === libTypeIds.MCQ;
  const [openMenuId, setOpenMenuId] = useState(null);
  const [openTopForm, setOpenTopForm] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const debouncedSearchText = useDebouncedValue(searchText, 500);

  // ✅ derive selected subject from already-fetched subjects list
  // const selectedSubject = useMemo(
  //   () => {
  //     return subjects.find((sub) => sub.id === +subId) ?? null;
  //   },
  //   [subId, subjects],
  // );

  const menuRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleMenuAction = useCallback((action, row) => {
    if (action === "edit") {
      setOpenTopForm(true);
      setEditRow(row);
      console.log("edit", row);
    } else if (action === "delete") {
      setEditRow(row);
      setOpenDeleteConfirm(true);
      console.log("delete", row);
    }
    setOpenMenuId(null);
  }, []);

  const renderTotalCol = useCallback(
    (col, row) => (
      <RowActionMenu
        row={row}
        openMenuId={openMenuId}
        onToggle={setOpenMenuId}
        onAction={handleMenuAction}
      />
    ),
    [openMenuId, handleMenuAction],
  );

  const TABLE_COLUMNS = useMemo(
    () => [
      {
        key: "tname",
        title: "TOPIC",
      },
      {
        key: "easy_count",
        title: "EASY",
      },
      {
        key: "medium_count",
        title: "MEDIUM",
      },
      {
        key: "hard_count",
        title: "HARD",
      },
      {
        key: "total_count",
        title: "TOTAL",
        render: renderTotalCol,
      },
    ],
    [renderTotalCol],
  );

  React.useEffect(() => {
    const controller = new AbortController();
    const fetchSubjects = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `node/subject?type=${type}&searchText=${debouncedSearchText}&isShared=${isShared}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            signal: controller.signal,
          },
        );
        if (data.resultCode === RESULT_STATUS.SUCCESS) {
          setSubjects(data.data);
        } else
          throw new Error(
            "Unable to fetch the subjects. Please try again later.",
          );
      } catch (error) {
        let isUnAuth = error?.response?.status === 403;
        if (error?.name === "CanceledError" || error?.name === "AbortError")
          return;
        setShowNotify({
          show: true,
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : "Unable to fetch the subjects. Please try again later",
          title: isUnAuth ? "Warning !" : "Error !",
          isUnAuth,
        });
      } finally {
        setLoading(false);
      }
    };
    if (!+subId && isMcq) fetchSubjects();
    return () => controller.abort();
  }, [
    axios,
    type,
    debouncedSearchText,
    subId,
    isShared,
    setShowNotify,
    isMcq,
    setSubjects,
  ]);

  React.useEffect(() => {
    if (isSharedPage) return;
    const controller = new AbortController();
    const fetchSubjectTopics = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `node/subject/topics?subId=${subId}&type=${type}&searchText=${debouncedSearchText}`,
          {
            headers: { "Content-Type": "application/json" },
            signal: controller.signal,
          },
        );
        if (data.resultCode === RESULT_STATUS.SUCCESS) {
          const newTopics = data?.data?.[0]?.topics || [];
          console.log("Setting subject:",data)
          setSelectedSubject({
            subName: data?.data?.[0]?.sname ?? "",
            subId: data.data?.[0]?.sid ?? ""
          });
          setTopics((prev) =>
            JSON.stringify(prev) === JSON.stringify(newTopics)
              ? prev
              : newTopics,
          );
        } else
          throw new Error(
            data.msg ?? "Unable to fetch the topics. Please try again later",
          );
      } catch (error) {
        let isUnAuth = error?.response?.status === 403;
        if (error?.name === "CanceledError" || error?.name === "AbortError")
          return;
        setShowNotify({
          show: true,
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : "Unable to fetch the topics. Please try again later",
          title: isUnAuth ? "Warning !" : "Error !",
          isUnAuth,
        });
      } finally {
        setLoading(false);
      }
    };
    if (+subId) fetchSubjectTopics();
    return () => controller.abort();
  }, [
    axios,
    subId,
    type,
    debouncedSearchText,
    isSharedPage,
    setTopics,
    setShowNotify,
  ]);

  const onClickSubject = (subId) => {
    setTopics([]);
    setSearchParams({ subId });
  };

  const onBackToSubjects = () => {
    setSearchParams({});
    setSearchText("");
  };

  const onCloseEditForm = () => {
    setEditRow(null);
    setOpenTopForm(false);
  };

  const onCloseDeleteModal = () => {
    setOpenDeleteConfirm(false);
  };

  const onDeleteTopic = async () => {
    try {
      console.log("editRow:", editRow);
      setOpenDeleteConfirm(false);
      const controller = new AbortController();
      const response = await axios.delete(`node/topic/${editRow.tid}`, {
        headers: { "Content-Type": "application/json" },
        signal: controller.signal,
      });
      if (response.data.resultCode !== RESULT_STATUS.SUCCESS) {
        throw new Error("Something went wrong in deleting the topic");
      }
      setTopics((prev) => prev.filter((p) => p.tid !== editRow.tid));
      setShowNotify({
        show: true,
        title: "Info",
        msg: response.data.msg,
      });
    } catch (error) {
      let isUnAuth = error?.response?.status === 403;
      if (error?.name === "CanceledError" || error?.name === "AbortError")
        return;
      setShowNotify({
        show: true,
        msg: isUnAuth
          ? "You have been logged-out due to inactivity. Login again."
          : "Unable to fetch the topics. Please try again later",
        title: isUnAuth ? "Warning !" : "Error !",
        isUnAuth,
      });
    }
  };

  const onTopicRowClick = (row) => {
    setSearchParams({ subId, topId: row.tid });
  };

  const breadcrumbItems = [
    {
      label: "Subject",
      href: `/library/${type}/subjects`
    },
    {
      label: `${selectedSubject.subName}`,
    },
  ];


  return loading ? (
    <Loading className="loading-indicator" />
  ) : !subId && isMcq ? (
    <div className="subjects-container">
      {subjects.length > 0 ? (
        subjects?.map((subject) => (
          <div
            className="subject-container"
            key={subject.id}
            onClick={() => onClickSubject(subject.id)}
          >
            <div className="subject-wrapper">
              <div className="subject-top-container">
                <Tooltip title={subject.name} isIcon={true}>
                  <p className="subject-title">{subject.name}</p>
                </Tooltip>
                <div className="subject-total-qn-container">
                  Total Questions
                  <br />
                  <span className="subject-total-qn-count">
                    {subject.total_count}
                  </span>
                </div>
              </div>
              <div className="subject-bottom-container">
                {Object.entries(complexityid).map(([key, value]) => (
                  <div
                    className={`subject-complexity-container subject-${key.toLowerCase()}-complexity`}
                    key={value}
                  >
                    {complexityIcon[value]}
                    <p className="subject-complexity">
                      {key}:{" "}
                      <span className="subject-complexity-qn-count">
                        {subject[`${key.toLowerCase()}_count`]}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))
      ) : (
        <NoSubjects />
      )}
    </div>
  ) : isSharedPage ? (
    <>
      <SharedTopics />
    </>
  ) : topId ? (
    <QuestionList />
  ) : (
    <>
      {/* <div
        className="library-question-list-back-btn-container"
        onClick={() => onBackToSubjects()}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="library-question-list-back-btn"
        >
          <path
            d="M12.5 15L7.5 10L12.5 5"
            stroke="#667085"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {selectedSubject}
      </div> */}
      <ReusableBreadcrumbs items={breadcrumbItems} />

      <Table
        className="subject-topics-table"
        columns={TABLE_COLUMNS}
        data={topics}
        bordered
        stripped={false}
        fixedHeader
        onRowClick={onTopicRowClick}
      />
      <Modal
        isOpen={openTopForm}
        onClose={onCloseEditForm}
        showCloseIcon={false}
        className="library-add-subject-modal"
      >
        <AddTopic
          setOpenSubModal={onCloseEditForm}
          isEdit={true}
          item={editRow}
          isLoading={loading}
          setIsLoading={setLoading}
        />
      </Modal>
      <Modal
        isOpen={openDeleteConfirm}
        onClose={onCloseDeleteModal}
        showCloseIcon={false}
        className="library-topic-delete-modal"
      >
        <ModalBody
          content={
            <p style={{ textAlign: "center" }}>
              Are you sure you want to delete this <br />
              Topic?
            </p>
          }
          footer={
            <>
              <Button
                size="sm"
                hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                onClick={() => setOpenDeleteConfirm(false)}
              />
              <Button
                size="sm"
                hierarchy={{
                  type: "primary",
                  buttonText: "Delete",
                }}
                onClick={onDeleteTopic}
              // disable={!!errors.name}
              />
            </>
          }
        />
      </Modal>
    </>
  );
});

export default Subjects;
